import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Image } from '@app/entities/images/interfaces/image';
import { ImageSelectors } from '@app/store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-item-preview',
  templateUrl: './item-preview.component.html',
  styleUrls: ['./item-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class ItemPreviewComponent {
  protected image$: Observable<Image> = inject(Store).select(
    ImageSelectors.image,
  ) as Observable<Image>;
}
